<ion-item
  (click)="clicked.emit()"
  [class.error]="isInvalid"
  lines="none"
>
  <ion-input
    [attr.maxlength]="maxlength ?? undefined"
    [formControl]="control"
    [placeholder]="placeholder ?? label"
    [readonly]="readonly"
    [spellcheck]="false"
    [required]="required"
    [style.font-size.px]="fontSizePx"
    [type]="type"
    autocapitalize="off"
    [autocorrect]="false"
    clear-input="true"
  >
    @if (type === 'password') {
      <ion-input-password-toggle
        aria-label="パスワード表示切替"
        slot="end"
      ></ion-input-password-toggle>
    }
  </ion-input>
</ion-item>

@if (isInvalid) {
  <div class="error-message">
    @for (msg of errorMessages; track $index) {
      <div>{{ msg }}</div>
    }
  </div>
}
